import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

type LegacyHiddenProps = {
  children: React.ReactNode;
  smDown?: boolean;
  smUp?: boolean;
  mdDown?: boolean;
  mdUp?: boolean;
  lgDown?: boolean;
  lgUp?: boolean;
  xlDown?: boolean;
  xlUp?: boolean;
};

const LegacyHidden: React.FC<LegacyHiddenProps> = (props) => {
  const { children, smDown, smUp, mdDown, mdUp, lgDown, lgUp, xlDown, xlUp } = props;
  const theme = useTheme();

  // Precompute all possible media queries
  const smDownMatch = useMediaQuery(theme.breakpoints.down('sm'));
  const smUpMatch = useMediaQuery(theme.breakpoints.up('sm'));
  const mdDownMatch = useMediaQuery(theme.breakpoints.down('md'));
  const mdUpMatch = useMediaQuery(theme.breakpoints.up('md'));
  const lgDownMatch = useMediaQuery(theme.breakpoints.down('lg'));
  const lgUpMatch = useMediaQuery(theme.breakpoints.up('lg'));
  const xlDownMatch = useMediaQuery(theme.breakpoints.down('xl'));
  const xlUpMatch = useMediaQuery(theme.breakpoints.up('xl'));

  let show = true;
  if (smDown) show = show && !smDownMatch;
  if (smUp) show = show && smUpMatch;
  if (mdDown) show = show && !mdDownMatch;
  if (mdUp) show = show && mdUpMatch;
  if (lgDown) show = show && !lgDownMatch;
  if (lgUp) show = show && lgUpMatch;
  if (xlDown) show = show && !xlDownMatch;
  if (xlUp) show = show && xlUpMatch;

  if (!show) return null;
  return <Box display="contents">{children}</Box>;
};

export default LegacyHidden;
